module.exports = __webpack_public_path__ + "img/grade_undefined.a859b2a.svg";